export const getHorseType = ({ damStatus, sireStatus }) => {
    if (damStatus) { return 'dam'; }
    if (sireStatus) { return 'sire'; }
    return 'horse';
};

export const hasProgeny = profile => getHorseType(profile) !== 'horse';




// WEBPACK FOOTER //
// ./src/js/utils/horse.js